import { ThemeService } from '@/app/core/services/theme.service';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'c-checked-theme',
  standalone: false,
  templateUrl: './checked-theme.component.html',
  styleUrl: './checked-theme.component.css',
})
export class CheckedThemeComponent {
  private themeService = inject(ThemeService);

  get theme(): boolean {
    return !this.themeService.isDark();
  }

  set theme(value: boolean) {
    this.themeService.setDark(!value);
  }
}
